import * as React from "react";

import "./xpresslinks-landing.scss";

import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {UseState}           from "@Common/react/use-state";
import {Responsive}         from "@Common/ui-components/responsive";
import {Load2}              from "@Common/react/load2";
import {XpresslinksMobile}  from "./xpresslinks-mobile/xpresslinks-mobile";
import {XpresslinksDesktop} from "./xpresslinks-desktop/xpresslinks-desktop";

const messageDefault = `Hello! I would like to get in touch. Please contact me at your earliest convenience.`

export const XpresslinksLanding = ({match}) => cs(
    consumeContext("apis"),
    ["encodedURL", ({}, next) => next(match.params.orderParams)],
    ["data", ({apis}, next) => Load2({
        fetch: async () => {
            try {
                const params = JSON.parse(atob(decodeURIComponent(match.params.orderParams)))
                if(!params.hasOwnProperty('idMailingListAddress')) {
                    const escapeSampleAddressReturn = -1
                    params['idMailingListAddress'] = escapeSampleAddressReturn
                }
                return apis.next.myNeighborhood.getXpresslinks(params)
            }
            catch(e) {
                return {
                    statusCode: "fail",
                    message: "Invalid URL"
                }
            }
        },
        next,
    })],
    ({data}, next) => (
        data.loading ? (
            <div className="xpresslinks-landing xpresslinks-landing-xll1">
                <div className="text">
                    Loading...
                </div>
            </div>
        ) : data.value.statusCode && data.value.statusCode != "success" ? (
            <div className="xpresslinks-landing xpresslinks-landing-xll1">
                <div className="text">
                    {data.value.message}
                </div>
            </div>
        ) : (
            next()
        )
    ),
    ["xpresslinksOptions", ({data}, next) => !data.loading && UseState({
        initValue: data.value.xpresslinksOptions,
        next,
    })],
    ["xpresslinksOptionsPreview", ({data}, next) => !data.loading && UseState({
        initValue: data.value.xpresslinksOptions,
        next,
    })],
    ["formData", ({data}, next) => !data.loading && UseState({
        initValue: {description: messageDefault},
        next,
    })],
    ["isEditable", ({data}, next) => !data.loading && UseState({
        initValue: data.value.isEditable,
        next,
    })],
    ["view", ({}, next) => UseState({
        initValue: PAGE_VIEW.PREVIEW,
        next,
    })],
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            sm: 700,
        },
        next,
    }}/>],
    ({data, xpresslinksOptions, xpresslinksOptionsPreview, formData, encodedURL, isEditable, view, responsive}) => (
        data.loading ? (
            <div className="xpresslinks-landing xpresslinks-landing-xll1">
                <div className="text">
                    Fetching your home value and similar homes in your area!
                </div>
            </div>
        ) : responsive.lt("sm") ? (
            XpresslinksMobile({data, isEditable, view, xpresslinksOptions, xpresslinksOptionsPreview, formData, encodedURL})
        ) : (
            XpresslinksDesktop({data, isEditable, view, xpresslinksOptions, xpresslinksOptionsPreview, formData, encodedURL})
        )
    ),
);

export const PAGE_VIEW = {
    PREVIEW: "PREVIEW",
    EDIT   : "EDIT",
}
